import { z } from 'zod';
import { UnixTimestamp } from '@triedge/domain-core/types';
import { SenderRoleSchema, ThreadStatusSchema } from '../types/enums';

export const MessageAttachmentSchema = z.object({
  resourceId: z.string(),
  name: z.string(),
  type: z.string(),
  size: z.number().nullable().optional(),
  uploadedAt: UnixTimestamp.nullable().optional(),
});
export type MessageAttachment = z.infer<typeof MessageAttachmentSchema>;

export const MessageThreadSchema = z.object({
  id: z.string(),
  subject: z.string(),
  participantIds: z.array(z.string()),
  familyId: z.string(),
  applicationId: z.string().nullable().optional(),
  lastMessageAt: UnixTimestamp,
  status: ThreadStatusSchema,
  unreadCount: z.number().int().nonnegative().default(0),
});
export type MessageThread = z.infer<typeof MessageThreadSchema>;

export const PortalMessageSchema = z.object({
  id: z.string(),
  threadId: z.string(),
  senderId: z.string(),
  senderRole: SenderRoleSchema,
  body: z.string(),
  sentAt: UnixTimestamp,
  readAt: UnixTimestamp.nullable().optional(),
  attachments: z.array(MessageAttachmentSchema).default([]),
});
export type PortalMessage = z.infer<typeof PortalMessageSchema>;
